import React, { useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  Typography
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { getLocalizedString } from "@icarius-localization/strings";

const TabTasks = (props) => {
  const { editMode, currentNode, handleChangeField, frequencies, color, theme } = props;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [frequency, setFrequency] = useState("");

  const items = currentNode["tasks"] || [];

  const handleAdd = () => {
    if (!name || !description || !frequency) return;
    const newTask = {
      name: name,
      description: description,
      frequency: frequency,
    };
    handleChangeField("tasks", [...items, newTask]);
    setName("");
    setDescription("");
    setFrequency("");
  };

  const handleDelete = (index) => {
    const newTasks = [...items];
    newTasks.splice(index, 1);
    handleChangeField("tasks", newTasks);
  };

  return (
    <div style={{ padding: 16 }}>
      {
        editMode && (
          <Paper style={{ padding: 16, marginBottom: 16, minHeight: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: theme?.theme === "dark" ? '#1e1f20' : "#f0f4f9" }}>
            <Typography className="whiteText" variant="subtitle1" style={{ marginBottom: 16 }}>
              {getLocalizedString("addTask")}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label={getLocalizedString("taskName")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  InputProps={{ className: "whiteText" }}
                  InputLabelProps={{ className: "whiteText" }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label={getLocalizedString("description")}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  InputProps={{ className: "whiteText" }}
                  InputLabelProps={{ className: "whiteText" }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <InputLabel className="whiteText" id="frecuencia-label">
                    {getLocalizedString("frequency")}
                  </InputLabel>
                  <Select
                    labelId="frecuencia-label"
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                    className="whiteText"
                  >
                    {
                      frequencies && frequencies.length > 0 &&
                      frequencies.map((item) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button
                  variant="contained"
                  onClick={handleAdd}
                  disabled={!name || !description || !frequency}
                  style={{ backgroundColor: color, marginTop: 12, minWidth: 'auto', padding: '6px 12px' }}
                >
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )
      }
      <List>
        {
          items.map((tarea, index) => {
            let freqLabel = tarea.frequency;
            const f = frequencies.find(x => x.key === tarea.frequency);
            if (f) freqLabel = f.value;

            return (
              <ListItem key={index} className="listItemBorderBottom">
                <ListItemText
                  primary={<span className="whiteText">{tarea.name} - {freqLabel}</span>}
                  secondary={<span className="whiteText">{tarea.description}</span>}
                />
                {editMode && (
                  <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={() => handleDelete(index)} style={{ color: '#ff4d4f' }}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
            )
          })
        }
        {
          items.length === 0 && (
            <Typography className="whiteText" style={{ textAlign: 'center', marginTop: 20, color: "var(--react-tel-arrow-color)" }}>
              {getLocalizedString("noTasksAdded")}
            </Typography>
          )
        }
      </List>
    </div>
  );
};

export default TabTasks;
